import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import UserProfileBadgeContainer from '@/creditflowresearch/ui/common/components/molecules/UserProfileBadgeContainer';
import UserProfileFallback from '@/creditflowresearch/ui/common/components/organisms/UserProfileFallback';

interface IUserProfileMenuTriggerProps {
  isActive: boolean,
  onClick?: () => void,
}

const UserProfileMenuTrigger: React.FC<IUserProfileMenuTriggerProps> = ({ isActive, onClick }) => {
  const { checkAccessByUserPlan } = useUserPlanContext();

  return (
    <CheckUserAccess
      conditions={ [{
      checks: [checkAccessByUserPlan(UserPlanType.STARTER)],
      fallback: <UserProfileFallback />,
    }] }
    >
      <UserProfileBadgeContainer
        onClick={ onClick }
        isActive={ isActive }
      />
    </CheckUserAccess>
  );
};

export default UserProfileMenuTrigger;
